document.addEventListener('DOMContentLoaded', function () {
  // ------------------------------------------
  // Input-mode detector (for focus outlines)
  // ------------------------------------------
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Tab') document.body.classList.add('user-is-tabbing');
  });
  document.addEventListener('mousedown', () => {
    document.body.classList.remove('user-is-tabbing');
  });

  // ------------------------------------------
  // Elements
  // ------------------------------------------
  const cartDrawer         = document.getElementById('nellaFinanceDrawer');
  const plansSection       = document.getElementById('financingPlansSection');
  const contactFormSection = document.getElementById('contactFormSection');
  const toggleContactBtn   = document.getElementById('contactToggleBtn');
  const footerButtons      = document.getElementById('footerButtons');
  const contactFormFooter  = document.getElementById('contactFormFooter');
  const backIconBtn        = document.getElementById('contactBackIconBtn');
  const planOptions        = document.querySelectorAll('.plan-option');
  const radios             = document.querySelectorAll('.plan-check');

  const leasingForm = document.getElementById('leasing_contact_form');
  const hiddenFinancingTerm = leasingForm?.querySelector('input[name="contact[financing_term]"]');

  const nameInput = document.getElementById('LeasingContactFormName')
                  || contactFormSection?.querySelector('input[name="contact[name]"]');

  // ------------------------------------------
  // Helpers
  // ------------------------------------------
  function openDrawer() {
    if (!cartDrawer) return;
    const openNow = () => {
      try {
        if (window.bootstrap && bootstrap.Offcanvas) {
          bootstrap.Offcanvas.getOrCreateInstance(cartDrawer).show();
        } else {
          cartDrawer.classList.add('show');
          cartDrawer.style.visibility = 'visible';
        }
      } catch (_) {}
    };
    if (window.bootstrap?.Offcanvas) openNow(); else setTimeout(openNow, 0);
  }

  function showContactForm() {
    plansSection?.classList.add('d-none');
    contactFormSection?.classList.remove('d-none');
    footerButtons?.classList.add('d-none');
    contactFormFooter?.classList.remove('d-none');
  }

  function showPlans() {
    plansSection?.classList.remove('d-none');
    contactFormSection?.classList.add('d-none');
    footerButtons?.classList.remove('d-none');
    contactFormFooter?.classList.add('d-none');
  }

  function setSelectedUI(radio) {
    planOptions.forEach(o => o.classList.remove('selected'));
    if (radio?.checked) radio.closest('.plan-option')?.classList.add('selected');
  }

  function updateHiddenTerm(radio) {
    if (!hiddenFinancingTerm) return;
    hiddenFinancingTerm.value = (radio && radio.checked) ? radio.value : '';
  }

  function clearSelection() {
    radios.forEach(r => { r.checked = false; r.blur(); });
    planOptions.forEach(o => o.classList.remove('selected'));
    updateHiddenTerm(null);
    lastChecked = null;
  }

  // ------------------------------------------
  // Drawer lifecycle
  // ------------------------------------------
  cartDrawer?.addEventListener('shown.bs.offcanvas', () => {
    document.body.classList.add('overflow-hidden', 'cart-drawer-open');
    setTimeout(() => nameInput?.focus(), 120);
  });
  cartDrawer?.addEventListener('hidden.bs.offcanvas', () => {
    document.body.classList.remove('overflow-hidden', 'cart-drawer-open');
    showPlans();
    clearSelection();
  });

  // Contact Sales → open drawer at Contact
  toggleContactBtn?.addEventListener('click', (e) => {
    e.preventDefault();
    openDrawer();
    showContactForm();
    setTimeout(() => nameInput?.focus(), 120);
  });

  // Back to plans
  backIconBtn?.addEventListener('click', (e) => {
    e.preventDefault();
    showPlans();
  });

  // ------------------------------------------
  // Radios: toggleable + hidden term sync
  // ------------------------------------------
  let lastChecked = null;

  radios.forEach(radio => {
    // CLICK (mouse): clicking the same one again unchecks it and removes lingering focus
    radio.addEventListener('click', function () {
      if (lastChecked === this) {
        this.checked = false;
        lastChecked = null;
        setSelectedUI(null);
        updateHiddenTerm(null);
        this.blur(); // important: kill lingering focus ring after uncheck (mouse)
      } else {
        lastChecked = this;
        setSelectedUI(this);
        updateHiddenTerm(this);
      }
    });

    // KEYBOARD: Space/Enter toggles but keeps focus for accessibility
    radio.addEventListener('keydown', function (e) {
      if (e.key === ' ' || e.key === 'Enter') {
        e.preventDefault();
        if (lastChecked === radio) {
          radio.checked = false;
          lastChecked = null;
          setSelectedUI(null);
          updateHiddenTerm(null);
          // keep focus for keyboard users (no blur)
        } else {
          radio.checked = true;
          lastChecked = radio;
          setSelectedUI(radio);
          updateHiddenTerm(radio);
        }
      }
    });
  });

  // Tag leasing submit + ensure hidden term is set
  leasingForm?.addEventListener('submit', () => {
    sessionStorage.setItem('submittedContactFormId', 'leasing_contact_form');
    const checked = leasingForm.querySelector('.plan-check:checked');
    updateHiddenTerm(checked || null);
  });

  // After redirect: ONLY open for leasing form (no fallback)
  (function autoOpenOnReturn(){
    const savedId = sessionStorage.getItem('submittedContactFormId');
    if (savedId === 'leasing_contact_form') {
      openDrawer();
      showContactForm();
      leasingForm?.querySelectorAll('[data-contact-success],[data-contact-errors]')
        .forEach(el => el.removeAttribute('hidden'));
      setTimeout(() => nameInput?.focus(), 120);
    }
    try { sessionStorage.removeItem('submittedContactFormId'); } catch(_){}
  })();
});
